<template>
  <div class="modal fade property-transfer-modal" tabindex="-1" role="dialog" aria-labelledby="propertyTransferModalLabel"
       aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-uppercase" id="propertyTransferModalLabel">Transfer Property</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <!-- Search for property section -->
          <div v-if="!propertyFound" class="row mb-4">
            <div class="col-12">
              <p class="text-capitalize">
                Search for the property you want to transfer by entering the LR Number below.
              </p>
              <div class="input-group">
                <input v-model="searchLRNumber" type="text" class="form-control" placeholder="Enter LR Number">
                <button @click="searchProperty" class="btn btn-primary" type="button">
                  <i class="bx bx-search font-size-16"></i> Search
                </button>
              </div>
            </div>
          </div>

          <!-- Property details section -->
          <div v-if="propertyFound" class="row">
            <div class="col-12">
              <div class="alert alert-info">
                <h5 class="alert-heading">Current Property Details</h5>
                <p class="mb-0">Property LR: <strong>{{ property.LRNumber }}</strong></p>
                <p class="mb-0">Current Owner: <strong>{{ property.ownerNames }}</strong></p>
                <p class="mb-0">Location: {{ property.percelAddress }}</p>
                <p class="mb-0">Outstanding Arrears: <strong>KES {{ numberFormat(property.outstandingArrears) }}</strong></p>
              </div>
            </div>

            <!-- Outstanding arrears warning -->
            <div v-if="property.outstandingArrears > 0" class="col-12 mb-4">
              <div class="alert alert-warning">
                <i class="bx bx-error-circle me-2"></i> This property has outstanding arrears. These must be cleared before transfer or will be transferred to the new owner.
              </div>
            </div>

            <!-- Transfer form -->
            <div class="col-12">
              <h5 class="text-uppercase mb-3">New Owner Information</h5>

              <div class="row">
                <div class="col-6 mb-3">
                  <div class="form-group">
                    <label for="newOwnerNames">New Owner's Full Name <span class="text-danger">*</span></label>
                    <input v-model="transferDetails.newOwnerNames" type="text" class="form-control" id="newOwnerNames" placeholder="Enter new owner's name">
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="form-group">
                    <label for="newOwnerID">National ID Number</label>
                    <input v-model="transferDetails.newOwnerID" type="text" class="form-control" id="newOwnerID" placeholder="Enter ID number">
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="form-group">
                    <label for="newOwnerPhoneNo">Phone Number <span class="text-danger">*</span></label>
                    <input v-model="transferDetails.newOwnerPhoneNo" type="text" class="form-control" id="newOwnerPhoneNo" placeholder="Enter phone number">
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="form-group">
                    <label for="newOwnerEmail">Email Address</label>
                    <input v-model="transferDetails.newOwnerEmail" type="email" class="form-control" id="newOwnerEmail" placeholder="Enter email address">
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="form-group">
                    <label for="newOwnerPassport">Kenyan Passport</label>
                    <input v-model="transferDetails.newOwnerPassport" type="text" class="form-control" id="newOwnerPassport" placeholder="Enter passport number">
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="form-group">
                    <label for="newOwnerDrivingLicence">Driving License</label>
                    <input v-model="transferDetails.newOwnerDrivingLicence" type="text" class="form-control" id="newOwnerDrivingLicence" placeholder="Enter driving license">
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="form-group">
                    <label for="newOwnerPinNumber">PIN Number</label>
                    <input v-model="transferDetails.newOwnerPinNumber" type="text" class="form-control" id="newOwnerPinNumber" placeholder="Enter PIN number">
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="form-group">
                    <label for="newOwnerBoxNo">P.O. Box Number</label>
                    <input v-model="transferDetails.newOwnerBoxNo" type="text" class="form-control" id="newOwnerBoxNo" placeholder="Enter P.O. Box number">
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="form-group">
                    <label for="newOwnerPostalCode">Postal Code</label>
                    <input v-model="transferDetails.newOwnerPostalCode" type="text" class="form-control" id="newOwnerPostalCode" placeholder="Enter postal code">
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="form-group">
                    <label for="newOwnerTown">Town</label>
                    <input v-model="transferDetails.newOwnerTown" type="text" class="form-control" id="newOwnerTown" placeholder="Enter town">
                  </div>
                </div>
              </div>

              <div class="col-12 mb-3">
                <h5 class="text-uppercase mb-3">Transfer Details</h5>
                <div class="row">
                  <div class="col-6 mb-3">
                    <div class="form-group">
                      <label for="transferType">Transfer Type <span class="text-danger">*</span></label>
                      <select v-model="transferDetails.transferType" class="form-select" id="transferType">
                        <option value="">Select transfer type</option>
                        <option value="SALE">Sale</option>
                        <option value="INHERITANCE">Inheritance</option>
                        <option value="GIFT">Gift</option>
                        <option value="COURT_ORDER">Court Order</option>
                        <option value="OTHER">Other</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-6 mb-3">
                    <div class="form-group">
                      <label for="transferDate">Transfer Date <span class="text-danger">*</span></label>
                      <input v-model="transferDetails.transferDate" type="date" class="form-control" id="transferDate">
                    </div>
                  </div>

                  <div class="col-12 mb-3">
                    <div class="form-group">
                      <label for="transferDocuments">Upload Transfer Documents (PDF, JPG, PNG) <span class="text-danger">*</span></label>
                      <input @change="handleFileChange" type="file" class="form-control" id="transferDocuments" multiple>
                      <small class="text-muted">Upload relevant transfer documents (sale agreement, court order, death certificate, etc.)</small>
                    </div>
                  </div>

                  <div class="col-12 mb-3">
                    <div class="form-group">
                      <label for="transferNotes">Additional Notes</label>
                      <textarea v-model="transferDetails.transferNotes" class="form-control" id="transferNotes" rows="3" placeholder="Enter any additional information about this transfer"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Loading state -->
          <div v-if="loading" class="text-center p-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-3">Processing, please wait...</p>
          </div>

          <!-- Success state -->
          <div v-if="transferComplete" class="text-center p-4">
            <div class="mb-4">
              <div class="avatar-sm rounded-circle bg-success mx-auto">
                <i class="mdi mdi-check-all font-size-24 avatar-title text-white"></i>
              </div>
            </div>
            <h4 class="text-black fw-bold">Property Transfer Complete</h4>
            <p class="text-muted mb-4">The property has been successfully transferred to {{transferDetails.newOwnerNames}}.</p>
            <p class="mb-0">Transfer Reference: <strong>{{transferReference}}</strong></p>
          </div>
        </div>

        <div class="modal-footer">
          <!-- Different buttons for different states -->
          <button v-if="!propertyFound && !loading" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>

          <button v-if="propertyFound && !loading && !transferComplete" type="button" class="btn btn-secondary" @click="resetSearch">Back to Search</button>
          <button v-if="propertyFound && !loading && !transferComplete" type="button" class="btn btn-primary" @click="submitTransfer">Process Transfer</button>

          <button v-if="transferComplete" type="button" class="btn btn-primary" @click="printTransferCertificate">Print Transfer Certificate</button>
          <button v-if="transferComplete" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {base, landRate, execute} from "@/api";

export default {
  name: "PropertyTransfer",
  data() {
    return {
      searchLRNumber: '',
      propertyFound: false,
      loading: false,
      transferComplete: false,
      transferReference: '',
      selectedFiles: [],
      property: {
        id: null,
        LRNumber: '',
        subCountyName: '',
        subCountyID: '',
        wardName: '',
        wardID: '',
        percelSize: '',
        lat: '',
        lng: '',
        percelAddress: '',
        ownerNames: '',
        ownerEmail: '',
        ownerPhoneNo: '',
        ownerID: '',
        outstandingArrears: 0,
        annualCharges: 0,
        block: '',
        zone: ''
      },
      transferDetails: {
        newOwnerNames: '',
        newOwnerEmail: '',
        newOwnerPhoneNo: '',
        newOwnerID: '',
        newOwnerPassport: '',
        newOwnerDrivingLicence: '',
        newOwnerPinNumber: '',
        newOwnerBoxNo: '',
        newOwnerPostalCode: '',
        newOwnerTown: '',
        transferType: '',
        transferDate: '',
        transferNotes: ''
      }
    };
  },
  methods: {
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },

    searchProperty() {
      if (!this.searchLRNumber) {
        alert("Please enter an LR Number to search");
        return;
      }

      this.loading = true;
      this.propertyFound = false;

      const data = new FormData();
      data.append("function", "getProperty");
      data.append("keyword", this.searchLRNumber);

      execute(data, landRate)
          .then((res) => {
            this.loading = false;

            if (res.data.success) {
              this.property = res.data.data.property;
              this.propertyFound = true;
            } else {
              alert(res.data.message || "Property not found");
            }
          })
          .catch((e) => {
            this.loading = false;
            alert("Error searching for property: " + e.message);
          });
    },

    resetSearch() {
      this.propertyFound = false;
      this.searchLRNumber = '';
      this.transferDetails = {
        newOwnerNames: '',
        newOwnerEmail: '',
        newOwnerPhoneNo: '',
        newOwnerID: '',
        newOwnerPassport: '',
        newOwnerDrivingLicence: '',
        newOwnerPinNumber: '',
        newOwnerBoxNo: '',
        newOwnerPostalCode: '',
        newOwnerTown: '',
        transferType: '',
        transferDate: '',
        transferNotes: ''
      };
      this.selectedFiles = [];
    },

    handleFileChange(event) {
      this.selectedFiles = event.target.files;
    },

    validateForm() {
      // Required fields
      if (!this.transferDetails.newOwnerNames) {
        alert("Please enter the new owner's name");
        return false;
      }

      if (!this.transferDetails.newOwnerPhoneNo) {
        alert("Please enter the new owner's phone number");
        return false;
      }

      if (!this.transferDetails.transferType) {
        alert("Please select a transfer type");
        return false;
      }

      if (!this.transferDetails.transferDate) {
        alert("Please select a transfer date");
        return false;
      }

      if (this.selectedFiles.length === 0) {
        alert("Please upload at least one supporting document");
        return false;
      }

      return true;
    },

    submitTransfer() {
      if (!this.validateForm()) {
        return;
      }

      this.loading = true;

      const data = new FormData();
      data.append("function", "transferProperty");
      data.append("propertyID", this.property.id);
      data.append("LRNumber", this.property.LRNumber);
      data.append("zone", this.property.zone);

      // Add old owner details for historical records
      data.append("oldOwnerNames", this.property.ownerNames);
      data.append("oldOwnerEmail", this.property.ownerEmail);
      data.append("oldOwnerPhoneNo", this.property.ownerPhoneNo);
      data.append("oldOwnerID", this.property.ownerID);

      // Add new owner details
      Object.keys(this.transferDetails).forEach(key => {
        data.append(key, this.transferDetails[key]);
      });

      // Add transfer metadata
      data.append("transferredBy", sessionStorage.getItem("sessionNames"));
      data.append("transferredByIDNo", sessionStorage.getItem("sessionIdNo"));

      // Add any files
      for (let i = 0; i < this.selectedFiles.length; i++) {
        data.append(`document_${i}`, this.selectedFiles[i]);
      }

      // Send the request
      execute(data, landRate)
          .then((res) => {
            this.loading = false;

            if (res.data.success) {
              this.transferComplete = true;
              this.transferReference = res.data.data.transferReference;
            } else {
              alert(res.data.message || "Failed to process transfer");
            }
          })
          .catch((e) => {
            this.loading = false;
            alert("Error processing transfer: " + e.message);
          });
    },

    printTransferCertificate() {
      // Store data for the print page
      localStorage['transferParams'] = JSON.stringify({
        transferReference: this.transferReference,
        propertyLRNumber: this.property.LRNumber,
        oldOwnerName: this.property.ownerNames,
        newOwnerName: this.transferDetails.newOwnerNames,
        transferDate: this.transferDetails.transferDate,
        transferType: this.transferDetails.transferType
      });

      // Open the certificate in a new window
      const routeData = this.$router.resolve({name: 'transfer-certificate'});
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style scoped>

</style>